import React from 'react';
import RubigramIcon from 'url:./assets/RubigramIcon.svg';
import OutcomeBanner from './OutcomeBanner';
import { RubigramStore } from '../_puzzles/Rubigram/RubigramStore';

const RubigramPreview = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="previewTile puzzleTile" onClick={onClick}>
      <div className="rubigramPreview">
        <div className="puzzleTitle">Rubigram</div>
        <div className="previewImageContainer">
          <img className="rubigramIcon" src={RubigramIcon}/>
          <OutcomeBanner store={RubigramStore as any} />
        </div>
      </div>
    </div>
  );
};

export default RubigramPreview;